(() => {
  const money = n => new Intl.NumberFormat('en-GB', {style: 'currency', currency: 'GBP', maximumFractionDigits: 0}).format(n);
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.dsgift__form');
    if (!form) return;
    const isLink = form.hasAttribute('data-dsgift-link');
    const radios = Array.from(form.querySelectorAll('.dsgift__amount input'));
    const customRadio = form.querySelector('[data-dsgift-custom-radio]');
    const custom = form.querySelector('[data-dsgift-custom-input]');
    const customBox = form.querySelector('[data-dsgift-custom-box]');
    const recipient = form.querySelector('[data-dsgift-recipient]');
    const name = form.querySelector('[data-dsgift-name]');
    const date = form.querySelector('[data-dsgift-date]');
    const offset = form.querySelector('[data-dsgift-offset]');
    const error = form.querySelector('[data-dsgift-error]');
    const price = form.querySelector('[data-dsgift-purchase-price]');
    const button = form.querySelector('[type=submit]');
    const buttonLabel = button.querySelector('[data-dsgift-submit-label]');
    const originalLabel = buttonLabel.textContent;
    let mapPromise, changeToken = 0, timer, submitting = false;
    async function getJSON(url) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Gift value lookup failed');
        return await response.json();
      } finally { clearTimeout(timeout); }
    }
    function getMap() {
      if (!mapPromise) mapPromise = getJSON(root.dataset.valuesUrl).then(data => {
        if (data.currency !== 'GBP' || data.min !== 50 || data.max !== 1000 || data.step !== 1 || !data.variants) throw new Error('Invalid gift values');
        return data.variants;
      }).catch(e => { mapPromise = undefined; throw e; });
      return mapPromise;
    }
    function showError(message) { error.textContent = message; error.hidden = !message; }
    function selected() {
      const radio = radios.find(el => el.checked);
      return {radio, amount: radio === customRadio ? Number(custom.value) : Number(radio?.dataset.amount)};
    }
    function validAmount(amount) { return Number.isInteger(amount) && amount >= 50 && amount <= 1000; }
    async function resolveValue() {
      const {radio, amount} = selected();
      if (!radio || !validAmount(amount)) throw new Error('Enter a whole-pound amount from £50 to £1,000.');
      const values = await getMap();
      const id = String(values[String(amount)] || '');
      if (!/^\d+$/.test(id)) throw new Error('This gift value is unavailable. Please choose another amount.');
      if (radio !== customRadio && radio.value !== id) throw new Error('Gift options have changed. Please refresh this page.');
      if (radio === customRadio && selected().amount === amount && radio.checked) radio.value = id;
      return {id, amount};
    }
    async function quote(value) {
      const url = new URL(root.dataset.productUrl, location.origin);
      url.searchParams.set('variant', value.id);
      url.searchParams.set('country', root.dataset.country);
      url.searchParams.set('section_id', 'drsknn-gift-quote');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal, cache: 'no-store'});
        if (!response.ok) throw new Error('Unable to confirm the current price. Please try again.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = JSON.parse(doc.querySelector('[data-dsgift-quote]')?.textContent || 'null');
        if (!result || String(result.id) !== value.id || result.amount !== value.amount || !result.available || !result.giftCard || !/^[A-Z]{3}$/.test(result.currency) || !(result.price > 0)) throw new Error('This gift value is unavailable. Please refresh and try again.');
        if (result.currency === 'GBP' && result.price !== value.amount * 100) throw new Error('The gift price has changed. Please contact the clinic before purchasing.');
        return result;
      } finally { clearTimeout(timeout); }
    }
    function delivery() {
      if (!recipient) return;
      const send = form.querySelector('[name="dsgift_delivery"]:checked').value === 'recipient';
      recipient.hidden = !send; recipient.disabled = !send;
      root.querySelector('[data-dsgift-to]').textContent = send && name.value.trim() ? 'For ' + name.value.trim() : 'A gift just for you';
    }
    const localDate = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    function refreshDates() {
      if (!date) return;
      const now = new Date(), last = new Date(now); last.setDate(last.getDate() + 90);
      date.min = localDate(now); date.max = localDate(last); offset.value = String(now.getTimezoneOffset());
    }
    function updateAmount(focus = false) {
      const token = ++changeToken;
      clearTimeout(timer); showError('');
      customBox.hidden = !customRadio.checked; custom.disabled = !customRadio.checked; custom.required = customRadio.checked;
      if (focus && customRadio.checked) custom.focus();
      const {radio, amount} = selected();
      if (!validAmount(amount)) {
        customRadio.value = '';
        root.querySelectorAll('[data-dsgift-value]').forEach(el => { el.textContent = '£—'; });
        if (price) price.textContent = 'Enter an amount';
        return;
      }
      root.querySelectorAll('[data-dsgift-value]').forEach(el => { el.textContent = money(amount); });
      if (radio !== customRadio) { if (price) price.textContent = radio.dataset.priceLabel; return; }
      if (price) price.textContent = 'Checking current price…';
      timer = setTimeout(async () => {
        try {
          const value = await resolveValue();
          const result = isLink ? null : await quote(value);
          if (token === changeToken && result) price.textContent = result.formatted;
        } catch (e) {
          if (token === changeToken) { if (price) price.textContent = 'Price unavailable'; showError('We couldn’t check this amount. Please try again or choose a preset.'); }
        }
      }, 250);
    }
    root.querySelector('[data-dsgift-custom-choice]').hidden = false;
    if (customRadio.checked) custom.value = root.dataset.selectedAmount;
    radios.forEach(radio => radio.addEventListener('change', () => updateAmount(true)));
    custom.addEventListener('input', () => updateAmount());
    form.querySelectorAll('[name="dsgift_delivery"]').forEach(el => el.addEventListener('change', delivery));
    name?.addEventListener('input', delivery);
    refreshDates(); delivery(); updateAmount();
    window.addEventListener('pageshow', event => {
      if (event.persisted) { submitting = false; button.disabled = false; buttonLabel.textContent = originalLabel; refreshDates(); delivery(); updateAmount(); }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting) return;
      refreshDates(); showError('');
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const snapshot = selected();
      let navigating = false;
      submitting = true; button.disabled = true; buttonLabel.textContent = 'Checking your gift…';
      try {
        const value = await resolveValue();
        const result = isLink ? null : await quote(value);
        if (snapshot.radio !== selected().radio || snapshot.amount !== selected().amount) throw new Error('Your amount changed. Please check it and continue.');
        if (result) price.textContent = result.formatted;
        if (!form.checkValidity()) { form.reportValidity(); return; }
        HTMLFormElement.prototype.submit.call(form);
        navigating = true;
      } catch (e) { showError(e.name === 'AbortError' ? 'The price check took too long. Please try again.' : e.message); }
      finally { if (!navigating) { submitting = false; button.disabled = false; buttonLabel.textContent = originalLabel; } }
    });
  }
  function scan() { document.querySelectorAll('[data-dsgift]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
